import { Calendar, LayoutGrid } from 'lucide-react'
import { useViewMode } from '@/context/ViewModeContext'

export function ViewModeToggle() {
  const { viewMode, toggleViewMode } = useViewMode()

  return (
    <button
      onClick={toggleViewMode}
      className="text-muted-foreground hover:text-foreground transition-colors p-2"
      aria-label={viewMode === 'day' ? 'Switch to week view' : 'Switch to day view'}
      title={viewMode === 'day' ? 'Week view' : 'Day view'}
    >
      {viewMode === 'day'
        ? <LayoutGrid className="w-5 h-5" strokeWidth={2} />
        : <Calendar className="w-5 h-5" strokeWidth={2} />}
    </button>
  )
}
